import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, RouteProps, useHistory } from "react-router-dom";
import DefaultLayout from "../layouts/default-layout/default-layout";
import { AppState } from "../store/app-state";
import { logout, updateAuthenticationToken } from "../store/auth/auth-actions";
import { useKeycloak } from "@react-keycloak/web";
import * as jose from "jose";

export interface PrivateRouteProps extends RouteProps {
  layout?: React.FC;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  layout,
  ...props
}) => {
  const { token, user } = useSelector((state: AppState) => state.authState);
  const SelectdLayout = layout || DefaultLayout;
  const { keycloak, initialized } = useKeycloak();
  const history = useHistory();
  const dispatch = useDispatch();

  const validateToken = useCallback(() => {
    try {
      if (token) {
        jose.decodeJwt(token);
      }
    } catch {
      dispatch(logout());
    }
  }, [token, dispatch]);

  useEffect(() => {
    if (initialized && !keycloak.authenticated) {
      validateToken();
      keycloak.login();
    } else if (keycloak.authenticated && keycloak.token) {
      dispatch(updateAuthenticationToken(keycloak.token));
    } else {
      validateToken();
    }
  }, [keycloak, initialized, dispatch, validateToken]);

  useEffect(() => {
    if (
      user &&
      !user?.setup &&
      window.location.pathname !== "/onboarding" &&
      user?.corporate
    ) {
      history.push("/onboarding");
    }
  }, [user, history]);


  useEffect(() => {
    if (
      user &&
      window.location.pathname !== "/onboarding/company" &&
      !user?.corporate
    ) {
      history.push("/onboarding/company");
    }
  }, [user, history]);

  return (
    <SelectdLayout>
      <Route
        {...props}
        render={(renderProps) =>
          initialized && token && Component ? (
            <Component {...renderProps} />
          ) : (
            <>Loading...</>
          )
        }
      />
    </SelectdLayout>
  );
};

export default PrivateRoute;
